const data = {
  // 农历新历时辰
  lunarHour: [
    {
      value: '24',
      solar: '未知',
      label: '未知',
    },
    {
      value: '0',
      solar: '0点',
      label: '00:00-00:59子',
    },
    {
      value: '1',
      solar: '1点',
      label: '01:00-01:59丑',
    },
    {
      value: '2',
      solar: '2点',
      label: '02:00-02:59丑',
    },
    {
      value: '3',
      solar: '3点',
      label: '03:00-03:59寅',
    },
    {
      value: '4',
      solar: '4点',
      label: '04:00-04:59寅',
    },
    {
      value: '5',
      solar: '5点',
      label: '05:00-05:59卯',
    },
    {
      value: '6',
      solar: '6点',
      label: '06:00-06:59卯',
    },
    {
      value: '7',
      solar: '7点',
      label: '07:00-07:59辰',
    },
    {
      value: '8',
      solar: '8点',
      label: '08:00-08:59辰',
    },
    {
      value: '9',
      solar: '9点',
      label: '09:00-09:59巳',
    },
    {
      value: '10',
      solar: '10点',
      label: '10:00-10:59巳',
    },
    {
      value: '11',
      solar: '11点',
      label: '11:00-11:59午',
    },
    {
      value: '12',
      solar: '12点',
      label: '12:00-12:59午',
    },
    {
      value: '13',
      solar: '13点',
      label: '13:00-13:59未',
    },
    {
      value: '14',
      solar: '14点',
      label: '14:00-14:59未',
    },
    {
      value: '15',
      solar: '15点',
      label: '15:00-15:59申',
    },
    {
      value: '16',
      solar: '16点',
      label: '16:00-16:59申',
    },
    {
      value: '17',
      solar: '17点',
      label: '17:00-17:59酉',
    },
    {
      value: '18',
      solar: '18点',
      label: '18:00-18:59酉',
    },
    {
      value: '19',
      solar: '19点',
      label: '19:00-19:59戌',
    },
    {
      value: '20',
      solar: '20点',
      label: '20:00-20:59戌',
    },
    {
      value: '21',
      solar: '21点',
      label: '21:00-21:59亥',
    },
    {
      value: '22',
      solar: '22点',
      label: '22:00-22:59亥',
    },
    {
      value: '23',
      solar: '23点',
      label: '23:00-23:59子',
    },
  ],
  calendar: [
    {
      value: '24',
      label: '未知',
    },
    {
      value: '0',
      label: '0点',
    },
    {
      value: '1',
      label: '1点',
    },
    {
      value: '2',
      label: '2点',
    },
    {
      value: '3',
      label: '3点',
    },
    {
      value: '4',
      label: '4点',
    },
    {
      value: '5',
      label: '5点',
    },
    {
      value: '6',
      label: '6点',
    },
    {
      value: '7',
      label: '7点',
    },
    {
      value: '8',
      label: '8点',
    },
    {
      value: '9',
      label: '9点',
    },
    {
      value: '10',
      label: '10点',
    },
    {
      value: '11',
      label: '11点',
    },
    {
      value: '12',
      label: '12点',
    },
    {
      value: '13',
      label: '13点',
    },
    {
      value: '14',
      label: '14点',
    },
    {
      value: '15',
      label: '15点',
    },
    {
      value: '16',
      label: '16点',
    },
    {
      value: '17',
      label: '17点',
    },
    {
      value: '18',
      label: '18点',
    },
    {
      value: '19',
      label: '19点',
    },
    {
      value: '20',
      label: '20点',
    },
    {
      value: '21',
      label: '21点',
    },
    {
      value: '22',
      label: '22点',
    },
    {
      value: '23',
      label: '23点',
    },{
      value: '24',
      label: '24点',
    }
  ],
}

export default data
